import React from "react";
import { QuestionMarkCircleIcon, EyeIcon } from "@heroicons/react/24/outline";
import Header from "../components/Header";
import staking from "../assets/images/staking-1.svg";
import step1 from "../assets/images/steps_1.svg";
import step2 from "../assets/images/steps_2.svg";
import step3 from "../assets/images/steps_3.svg";
import Footer from "../components/Footer";
import coin1 from "../assets/images/coin1.png";
import { useDisclosure } from '@mantine/hooks';
import { Modal, Button } from '@mantine/core';

const EthStaking = () => {
    const [opened, { open, close }] = useDisclosure(false);

  return (
    <>
   <div className='bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300'>
      <Header />
      <div className="px-4 py-6 lg:py-0 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <div>
            <h1 className="text-3xl lg:text-5xl font-bold text-gray-900">
              ETH Staking
            </h1>
            <p className="mt-2 text-gray-600 text-lg">
              Earn daily yield &amp; Utilize your staking
            </p>
            <div className="mt-3 flex items-center gap-1 text-yellow-500 font-medium cursor-pointer text-sm">
              <span>What is Staking?</span>
              <QuestionMarkCircleIcon className="w-4 h-4" />
            </div>
          </div>

          <div className="">
            <img src={staking} alt="" className="" />
          </div>
        </div>

        <div className="mb-16  grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 items-start">
          <div className="col-span-2">
            <div className="flex items-center justify-between text-sm text-gray-500">
              <span className="font-medium flex items-center gap-1">
                My Staked <EyeIcon className="w-4 h-4" />
              </span>
              <span>Total Profit</span>
            </div>

            <div className="mt-2 flex items-center justify-between">
              <div>
                <div className="text-2xl font-bold text-black">0.00 STAKE</div>
                <div className="text-gray-400 text-sm">≈ $0.00</div>
              </div>
              <div className="text-right">
                <div className="text-2xl font-bold text-black">0.00 STAKE</div>
                <div className="text-gray-400 text-sm">≈ $0.00</div>
              </div>
            </div>

            <a href="/simpleEarn" className="inline-block mt-6 bg-yellow-400 hover:bg-yellow-500 transition-all text-black font-semibold px-6 py-2 rounded-lg">
              Subscribe
            </a>
             <Modal opened={opened} onClose={close} title="Authentication">
        {/* Modal content */}
      </Modal>

      <Button variant="default" onClick={open}>
        Subscribe
      </Button>
          </div>
        </div>

        <div className="col-span-2 grid grid-cols-1 md:grid-cols-3 mt-6 lg:mt-0">
          <div className="rounded-xl border p-8">
            <div className="text-sm text-gray-500 font-medium flex items-center gap-1">
              Reference APR <EyeIcon className="w-4 h-4" />
            </div>
            <div className="text-2xl font-semibold mt-2">2.59%</div>
          </div>

          <div className="rounded-xl border p-8 md:mx-4 my-2 md:my-0 bg-primary text-secondary">
            <div className="text-md text-secondary font-medium flex items-center gap-1">
              Conversion Ratio <EyeIcon className="w-4 h-4" />
            </div>
            <div className="text-lg font-medium mt-2">
              1 WBSTAKE ≈ 1.07509043 STAKE
            </div>
          </div>

          <div className="rounded-xl border p-8">
            <div className="text-sm text-gray-500 font-medium flex items-center gap-1">
              Total Value Staked <EyeIcon className="w-4 h-4" />
            </div>
            <div className="text-lg font-semibold mt-2">2,959,000.00 STAKE</div>
          </div>
        </div>

        <section className="bg-secondary text-white rounded-lg lg:mb-12 mt-20 py-8 ">
          <div className="max-w-7xl mx-auto px-4 pb-12 text-center">
            <h2 className="text-2xl md:text-3xl font-semibold mb-12">
              Start Earning in 3 Steps
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 text-center">
              <div className="flex flex-col items-center">
                <img src={step1} alt="Stake" className="mb-4 border border-primary rounded-full p-6" />
                {/* <div className="text-sm bg-gray-100 w-8 h-8 flex items-center justify-center rounded-md font-semibold text-gray-800 mb-2">
                  1
                </div> */}
                <h3 className="font-semibold text-white mb-4 text-2xl">Stake</h3>
                <p className="text-sm text-white max-w-xs">
                  Stake, receive WBETH based on the daily conversion ratio.
                </p>
              </div>

              <div className="flex flex-col items-center">
                <img
                  src={step2}
                  alt="Earn Daily Rewards"
                  className="mb-4 border border-primary rounded-full p-6"
                />
                {/* <div className="text-sm bg-gray-100 w-8 h-8 flex items-center justify-center rounded-md font-semibold text-gray-800 mb-2">
                  2
                </div> */}
                <h3 className="font-semibold text-white mb-4 text-2xl">
                  Earn Daily Rewards
                </h3>
                <p className="text-sm text-white max-w-xs">
                  Earn yield by holding WBETH or use your WBETH for a variety of
                  <a href="#" className="text-blue-500 underline">
                    use cases
                  </a>
                  .
                </p>
              </div>

              <div className="flex flex-col items-center">
                <img src={step3} alt="Redeem" className="mb-4 border border-primary rounded-full p-6" />
                {/* <div className="text-sm bg-gray-100 w-8 h-8 flex items-center justify-center rounded-md font-semibold text-gray-800 mb-2">
                  3
                </div> */}
                <h3 className="font-semibold text-white mb-4 text-2xl">
                  Flexibility to Redeem Stake
                </h3>
                <p className="text-sm text-white max-w-xs">
                  Redeem WBETH for Stake.
                </p>
              </div>
            </div>
          </div>
        </section>

        <div className="py-6 rounded-lg px-4">
          <h3 className="text-3xl lg:text-5xl font-bold text-gray-900">
            Popular Plans
          </h3>
        </div>
        <section className="lg:my-16 md:flex justify-center items-center gap-8">
          <div className="border border-yellow-400 rounded-lg p-4 w-full max-w-sm shadow-sm bg-white">
            <div className="flex justify-between items-start mb-2">
              <div>
                <h2 className="text-gray-900 font-semibold text-lg">ETHUSDT</h2>
                <div className="text-xs text-gray-500 mt-1 space-x-1">
                  <span>Perp</span>
                  <span className="text-green-600 font-medium">| Long 7x</span>
                  <span>| Trailing</span>
                  <span>👥 8</span>
                </div>
              </div>
              <a href="/simpleEarn" className="bg-yellow-400 text-black text-sm font-medium px-3 py-1 rounded inline-block">
                Copy
              </a>
            </div>

            <div className="mt-4">
              <p className="text-xs text-gray-500">PNL (USD)</p>
              <p className="text-green-600 text-2xl font-semibold">
                +34,913.88
              </p>
            </div>

            <div className="my-4 flex items-center justify-start">
              <img src={coin1} alt="" className="h-14 w-14" />
            </div>

            <div className="flex justify-between text-xs text-gray-700">
              <div>
                <p className="text-gray-500">ROI</p>
                <p className="font-medium">+9.15%</p>
              </div>
              <div>
                <p className="text-gray-500">Runtime</p>
                <p className="font-medium">1d 2h 4m</p>
              </div>
              <div>
                <p className="text-gray-500">Min. Investment</p>
                <p className="font-medium">688.80 USDT</p>
              </div>
            </div>

            <div className="flex justify-between mt-6 text-xs text-gray-700">
              <div>
                <p className="text-gray-500">24H/Total Matched Trades</p>
                <p className="font-medium">73/82</p>
              </div>
              <div>
                <p className="text-gray-500">7D MDD</p>
                <p className="font-medium">7.98%</p>
              </div>
            </div>
          </div>
          <div className="border border-yellow-400 rounded-lg p-4 w-full max-w-sm shadow-sm bg-white my-4 md:my-0">
            <div className="flex justify-between items-start mb-2">
              <div>
                <h2 className="text-gray-900 font-semibold text-lg">ETHUSDT</h2>
                <div className="text-xs text-gray-500 mt-1 space-x-1">
                  <span>Perp</span>
                  <span className="text-green-600 font-medium">| Long 7x</span>
                  <span>| Trailing</span>
                  <span>👥 8</span>
                </div>
              </div>
              <a href="/simpleEarn" className="bg-yellow-400 text-black text-sm font-medium px-3 py-1 rounded inline-block">
                Copy
              </a>
            </div>

            <div className="mt-4">
              <p className="text-xs text-gray-500">PNL (USD)</p>
              <p className="text-green-600 text-2xl font-semibold">
                +34,913.88
              </p>
            </div>

            <div className="my-4 flex items-center justify-start">
              <img src={coin1} alt="" className="h-14 w-14" />
            </div>

            <div className="flex justify-between text-xs text-gray-700">
              <div>
                <p className="text-gray-500">ROI</p>
                <p className="font-medium">+9.15%</p>
              </div>
              <div>
                <p className="text-gray-500">Runtime</p>
                <p className="font-medium">1d 2h 4m</p>
              </div>
              <div>
                <p className="text-gray-500">Min. Investment</p>
                <p className="font-medium">688.80 USDT</p>
              </div>
            </div>

            <div className="flex justify-between mt-6 text-xs text-gray-700">
              <div>
                <p className="text-gray-500">24H/Total Matched Trades</p>
                <p className="font-medium">73/82</p>
              </div>
              <div>
                <p className="text-gray-500">7D MDD</p>
                <p className="font-medium">7.98%</p>
              </div>
            </div>
          </div>
          <div className="border border-yellow-400 rounded-lg p-4 w-full max-w-sm shadow-sm bg-white">
            <div className="flex justify-between items-start mb-2">
              <div>
                <h2 className="text-gray-900 font-semibold text-lg">ETHUSDT</h2>
                <div className="text-xs text-gray-500 mt-1 space-x-1">
                  <span>Perp</span>
                  <span className="text-green-600 font-medium">| Long 7x</span>
                  <span>| Trailing</span>
                  <span>👥 8</span>
                </div>
              </div>
              <a href="/simpleEarn" className="bg-yellow-400 text-black text-sm font-medium px-3 py-1 rounded inline-block">
                Copy
              </a>
            </div>

            <div className="mt-4">
              <p className="text-xs text-gray-500">PNL (USD)</p>
              <p className="text-green-600 text-2xl font-semibold">
                +34,913.88
              </p>
            </div>

            <div className="my-4 flex items-center justify-start">
              <img src={coin1} alt="" className="h-14 w-14" />
            </div>

            <div className="flex justify-between text-xs text-gray-700">
              <div>
                <p className="text-gray-500">ROI</p>
                <p className="font-medium">+9.15%</p>
              </div>
              <div>
                <p className="text-gray-500">Runtime</p>
                <p className="font-medium">1d 2h 4m</p>
              </div>
              <div>
                <p className="text-gray-500">Min. Investment</p>
                <p className="font-medium">688.80 USDT</p>
              </div>
            </div>

            <div className="flex justify-between mt-6 text-xs text-gray-700">
              <div>
                <p className="text-gray-500">24H/Total Matched Trades</p>
                <p className="font-medium">73/82</p>
              </div>
              <div>
                <p className="text-gray-500">7D MDD</p>
                <p className="font-medium">7.98%</p>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
   </div>
    </>
  )
}

export default EthStaking